import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      '& *:focus': {
        outline: 'none !important'
      }
    },
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto'
    },
    '@global': {
      '*::-webkit-scrollbar': {
        width: '0.4em',
        height: '0.4em',
        zIndex: 1
      },
      '*::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
      },
      '*::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.1)',
        outline: '1px solid slategrey'
      }
    }
  });
